import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class BaoCaoSanLuongA0Service {

  constructor(
    public api: ApiService

  ) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy báo cáo thống kê
  public getBaocaosanluongA0(danhmucid, tungay, denngay, loaidiemdo, mataikhoan, pagenum, numrecs) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_BC_SL_A0.P_BAOCAO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_loaidiemdo: loaidiemdo,
        v_mataikhoan: mataikhoan,
        v_pagenum: pagenum,
        v_numrecs: numrecs
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

  exportExcel(danhmucid, tungay, denngay, loaiHienThi, tendonvi, tenchucnang, noidungbaocao, thoigian, mataikhoan) {
    let columns = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "makhachhang", "label": "Mã Khách Hàng", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số Công Tơ", "horizontalalignment": "center" },
      { "name": "hsn", "label": "HSN", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao", "label": "Tổng SL giao (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao1", "label": "Tổng SL giao biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao2", "label": "Tổng SL giao biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluonggiao3", "label": "Tổng SL giao biểu 3 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan", "label": "Tổng SL nhận (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan1", "label": "Tổng SL nhận biểu 1 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan2", "label": "Tổng SL nhận biểu 2 (kwh)", "horizontalalignment": "right" },
      { "name": "tongsanluongnhan3", "label": "Tổng SL nhận biểu 3 (kwh)", "horizontalalignment": "right" },
    ];
    let para: any = JSON.stringify({
      v_Danhmucid: danhmucid,
      v_Tungay: tungay,
      v_Denngay: denngay,
      v_LoaiHienThi: loaiHienThi,
      v_pagenum: 0,
      v_numrecs: 1000000,
      v_mataikhoan: mataikhoan
    });
    let config = JSON.stringify({ namesql: "PKG_BC_SANLUONG.THONGKESANLUONG", connstr: "Amiss42" });
    return this.api.exportExcel("", columns, para, config, tendonvi, tenchucnang, noidungbaocao, thoigian);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/bao-cao/bao-cao-san-luong-A0/baocaosanluongA0.service.ts